module.exports = __webpack_public_path__ + "img/is.b4543794.svg";